import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardLeftIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M0.5 22L15.5 22C15.7761 22 16 21.7761 16 21.5V20.5C16 20.2239 15.7761 20 15.5 20H0.5C0.223858 20 0 20.2239 0 20.5V21.5C0 21.7761 0.223858 22 0.5 22Z"
        fill={color}
      />
      <path
        d="M0.5 10L15.5 10C15.7761 10 16 9.77614 16 9.5V8.5C16 8.22386 15.7761 8 15.5 8L0.5 8C0.223858 8 0 8.22386 0 8.5V9.5C0 9.77614 0.223858 10 0.5 10Z"
        fill={color}
      />
      <path
        d="M0.5 4L23.5 4C23.7761 4 24 3.77614 24 3.5V2.5C24 2.22386 23.7761 2 23.5 2L0.5 2C0.223858 2 0 2.22386 0 2.5V3.5C0 3.77614 0.223858 4 0.5 4Z"
        fill={color}
      />
      <path
        d="M0.5 16L23.5 16C23.7761 16 24 15.7761 24 15.5V14.5C24 14.2239 23.7761 14 23.5 14L0.5 14C0.223858 14 0 14.2239 0 14.5V15.5C0 15.7761 0.223858 16 0.5 16Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardLeftIcon.displayName = 'BoardLeftIcon';
